<template>
	<b-modal static centered :id="modalData.id" :visible="modalData.visible" title-tag="h2" title-class="h5" header-bg-variant="danger" header-text-variant="light" :no-close-on-backdrop="!modalData.allowClose" :no-close-on-esc="!modalData.allowClose" :no-ok="!modalData.allowClose" :ok-only="modalData.okOnly" :hide-header-close="!modalData.allowClose" ok-only :ok-disabled="!modalData.allowClose" :hide-footer="!modalData.allowClose" ok-variant="dark">
		<div slot="modal-title">Error</div>
		<b-container class="text-center">
			<b-row>
				<b-col class="text-justify" v-html="modalData.message"></b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
	export default
	{
		name: 'error-modal',
		props: [ 'modalData' ],
		data() { return {}; }
	}
</script>
